import {
  UserProfileLinkGroupDocument,
  UserProfileLinkGroupMutationResult,
  UserProfileLinkGroupMutationVariables,
} from "@graphql/api";

interface UpdateData {
  clientid?: string;
  data1?: string;
  data2?: string;
  groupid?: string;
  webid?: string;
}

export default async function userProfileLinkGroup(
  id: number,
  fields: UpdateData,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileLinkGroupMutationVariables = { id, ...fields };
  const result: UserProfileLinkGroupMutationResult = await client.mutate({
    mutation: UserProfileLinkGroupDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileLinkGroup.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileLinkGroup.success;
}
